import React from "react";

import Container from "react-bootstrap/Container";

const Header = () => (
  <div className="parallax">
    <Container>
      <div className="vertical-center jumbotron">
        <h1 className="name-header">Scott Schretzenmaier</h1>
        <p id="name-description">Engineer bridging software and the physical world</p>
      </div>
    </Container>
  </div>
);

export default Header;
